// extracted by mini-css-extract-plugin
export default {"selection":"styles_selection__f9s5G","actions":"styles_actions__tZboi"};